<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>服务费汇总</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">

                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" @change="cityChange">
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityAddress" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="服务站">
                    <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站">
                        <el-option v-for="(item,index) in stationList" :key="index" :label="item.stationName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="服务者">
                    <el-input v-model="listQuery.workerName" placeholder="请输入服务者姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="服务费类型">
                    <el-select v-model="choosesalaryTypes" clearable placeholder="请选择类型" multiple>
                        <el-option clearable v-for="(item,index) in salaryTypeList" :key="index" :label="item.salaryTypeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="listQuery.workerTel" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>
                <el-form-item label="服务费月份">
                    <el-date-picker v-model="listQuery.timePart" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" value-format="yyyyMM" :picker-options="{}" @change="dateChange"></el-date-picker>
                </el-form-item>
                <el-form-item label="上线时间">
                    <el-date-picker v-model="listQuery.entryTime" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                    <el-button type="primary" icon="el-icon-download" @click="downloadSalary" v-per="'salaryDownload'">导出</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>

                <el-table-column prop="workerNo" label="编号" width="100px" fixed="left"></el-table-column>
                <el-table-column prop="workerName" label="姓名"></el-table-column>
                <el-table-column prop="entryTime" label="上线日期" width="140px"></el-table-column>
                <el-table-column prop="city" label="城市"></el-table-column>
                <el-table-column prop="jzStation" label="驿站"></el-table-column>
                <el-table-column prop="station" label="服务站"></el-table-column>
                <!-- <el-table-column prop="workerTel" label="手机号"></el-table-column> -->
                <el-table-column prop="sumSalary" label="总服务费"></el-table-column>
                  <el-table-column prop="yearMh" label="所属月份"></el-table-column>

                <el-table-column v-if="checktd(1)" prop="jingxuan" label="鲸选"></el-table-column>
                <el-table-column  v-if="checktd(2)" prop="xinnonbao" label="新农保"></el-table-column>
                <el-table-column v-if="checktd(3)"  prop="zhafei" label="杂费"></el-table-column>
                <el-table-column v-if="checktd(4)"  prop="shengsujieguo" label="申诉结果"></el-table-column>
                <el-table-column v-if="checktd(5)"  prop="gondanjiti" label="工单计提"></el-table-column>
                <el-table-column v-if="checktd(6)"  prop="baoxianfei" label="保险费"></el-table-column>
                <el-table-column v-if="checktd(7)"  prop="gendanfei" label="跟单费"></el-table-column>
                <el-table-column v-if="checktd(8)"  prop="zhusufei" label="住宿费"></el-table-column>
                <el-table-column v-if="checktd(9)"  prop="sushezhang" label="宿舍长补贴"></el-table-column>
                <el-table-column v-if="checktd(10)"  prop="shifujiang" label="师傅奖"></el-table-column>
                <el-table-column v-if="checktd(11)"  prop="baodibutie" label="保底补贴"></el-table-column>
                <el-table-column v-if="checktd(12)"  prop="fugoujiangli" label="复购奖励"></el-table-column>
                <el-table-column v-if="checktd(13)"  prop="fadan" label="罚单"></el-table-column>
                <el-table-column v-if="checktd(14)"  prop="yajing" label="押金"></el-table-column>
                <el-table-column v-if="checktd(15)"  prop="wuliaofei" label="物料费"></el-table-column> 
              
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

                <el-table-column prop label="操作" fixed="right" width="150px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showCategoryDetail(scope.row)">详情</el-button>

                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import Service from "../script/api/service";
import url from "@/script/baseUrl.js";
import globalData from "@/components/common/globaldata/global.data.vue";
export default {
    components: { Pagination },
    data() {
        return {
            salaryTypeList:[],
            choosesalaryTypes: [], 
            exportSalaryUrl:
                url.salaryUrl +
                "/salary/exportSalarySummary?token=" +
                window.localStorage.getItem("token"),
            cityList: [],
            stationList: [],
            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                cityId: "",
                stationId: "",
                workerName: "",
                workerTel: "",
                timePart: null,
                entryTime: [],
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "今年至今",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近六个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一年",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 12);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
        };
    },
    mounted() {
        let currentTime = new Date().getTime();
        let currentDate = this.formateDay(
            new Date(currentTime - 3600 * 1000 * 24 * 1)
        );
        let startDate = this.formateDay(
            new Date(currentTime - 3600 * 1000 * 24 * 30)
        );
        this.$set(this.listQuery, "timePart", [
            moment().format("YYYYMM"),
            moment().format("YYYYMM"),
        ]);

        this.querySearch();
    },
    created() {
        this.cityList = JSON.parse(window.localStorage.getItem("allCityList"));
        if (!window.localStorage.getItem("allCityList")) {
        Service
          .$axiosGetAllCityStation({
            // userId:  JSON.parse(window.localStorage.getItem("userInfo")).id
          })
          .then(res => {
            if (res.data.errno == "0") {
                this.cityList ==res.data.data;
              window.localStorage.setItem("allCityList",JSON.stringify(this.cityList) );
            } else {
              this.$message.warning(res.data.errmsg);
            }

          })
      }
        this.getTypeList();
    },
    methods: {
        checktd(id){
            let boo=false;
             this.choosesalaryTypes.forEach(e=>{
                if(e==id){
                    boo=true;
                }
             })
             return boo;
        },
        getTypeList() {
            Service.$axiosGetAllSalaryType()
                .then((res) => {
                    this.salaryTypeList = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //查询
        querySearch() {
            if (
                this.listQuery.timePart == null ||
                this.listQuery.timePart.length == 0
            ) {
                this.$message.error("选择服务费月份");
                return;
            }
            let temp = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                cityId: this.listQuery.cityId,
                stationId: this.listQuery.stationId,
                workerName: this.listQuery.workerName,
                workerTel: this.listQuery.workerTel,
            };
            if (
                this.listQuery.timePart != "" &&
                this.listQuery.timePart != undefined
            ) {
                temp.startMonth = moment(this.listQuery.timePart[0]).format(
                    "YYYYMM"
                );
                temp.endMonth = moment(this.listQuery.timePart[1]).format(
                    "YYYYMM"
                );
            }
            if (
                this.listQuery.entryTime != "" &&
                this.listQuery.entryTime != undefined
            ) {
                temp.entryStartTime = this.listQuery.entryTime[0];
                temp.entryEndTime = this.listQuery.entryTime[1];
            }

            Service.$axiosSelectSalarySummary(temp)
                .then((res) => {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        cityChange(value) {
            this.listQuery.stationId = "";
            let currentStation = this.cityList.filter((item) => {
                return item.id == value;
            });
            this.stationList = currentStation[0].stationList;
        },
        dateChange(e) {
            if (e != null) {
                let start =
                    new Date(e[0]).getFullYear() * 12 +
                    new Date(e[0]).getMonth();
                let end =
                    new Date(e[1]).getFullYear() * 12 +
                    new Date(e[1]).getMonth();
                let isOvertime = end - start - 12 > 0;
                // if (isOvertime) {
                //   this.$message.warning("选中时间范围不能超过一年");
                //   this.listQuery.timePart = null;
                // }
            }
        },
        downloadSalary() {
            if (
                this.listQuery.timePart == null ||
                this.listQuery.timePart.length == 0
            ) {
                this.$message.error("选择服务费月份");
                return;
            }
            let startMonth = "";
            let endMonth = "";
            if (
                this.listQuery.timePart != "" &&
                this.listQuery.timePart != undefined
            ) {
                startMonth = moment(this.listQuery.timePart[0]).format(
                    "YYYYMM"
                );
                endMonth = moment(this.listQuery.timePart[1]).format("YYYYMM");
            }
            let params = `&pageSize=${this.pageSize}&pageNum=${this.currentPage}&cityId=${this.listQuery.cityId}&stationId=${this.listQuery.stationId}&workerName=${this.listQuery.workerName}&workerTel=${this.listQuery.workerTel}&startMonth=${startMonth}&endMonth=${endMonth}`;
            window.open(this.exportSalaryUrl + params);
        },
        showCategoryDetail(row) {
            this.$router.push({
                path: "/salaryManage/salaryDetail",
                query: {
                    workerNo: row.workerNo,
                    yearMonth: row.yearMh,
                },
            });
        },
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
</style>